/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconRadioActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8zm11.376-5.847A6.747 6.747 0 0 1 14.75 8a6.747 6.747 0 0 1-3.374 5.847l-.75-1.3A5.248 5.248 0 0 0 13.25 8a5.248 5.248 0 0 0-2.625-4.547l.75-1.3zM1.25 8a6.747 6.747 0 0 1 3.374-5.847l.75 1.3A5.248 5.248 0 0 0 2.75 8a5.248 5.248 0 0 0 2.624 4.547l-.75 1.3A6.747 6.747 0 0 1 1.25 8zm2.5 0c0-1.573.854-2.946 2.124-3.681l.75 1.299a2.749 2.749 0 0 0 0 4.764l-.75 1.299A4.248 4.248 0 0 1 3.75 8zm5.625-2.382.75-1.3A4.248 4.248 0 0 1 12.25 8a4.248 4.248 0 0 1-2.125 3.681l-.75-1.3a2.749 2.749 0 0 0 0-4.763zM6.545 8a1.455 1.455 0 1 1 2.91 0 1.455 1.455 0 0 1-2.91 0z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11zM3 12c0-3.331 1.81-6.24 4.5-7.796l1 1.733A6.997 6.997 0 0 0 5 12a6.997 6.997 0 0 0 3.5 6.063l-1 1.733A8.996 8.996 0 0 1 3 12zm13.5-7.795A8.996 8.996 0 0 1 21 12c0 3.33-1.81 6.24-4.5 7.795l-1-1.732A6.997 6.997 0 0 0 19 12a6.997 6.997 0 0 0-3.5-6.063l1-1.732zM6.75 12a5.248 5.248 0 0 1 2.624-4.547l1 1.732a3.249 3.249 0 0 0 0 5.63l-1 1.732A5.248 5.248 0 0 1 6.75 12zm6.875-2.815 1-1.732A5.248 5.248 0 0 1 17.25 12a5.248 5.248 0 0 1-2.625 4.548l-1-1.733a3.249 3.249 0 0 0 0-5.63zM10.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconRadioActive is deprecated and will be archived soon. Use IconRadioActive instead.
 */
export function Experimental__IconRadioActive(props) {
  return /*#__PURE__*/React.createElement(IconRadioActive, props);
}